import { styled } from 'styled-components';

import { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';
import { colors, fontWeights, transition } from '#/theme/theme';

export const LayoutHeaderAnniversaryBannerHolder = styled.div`
  position: relative;

  .hide-small {
    @media all and (max-width: 639px) {
      display: none;
    }
  }
`;

export const LayoutHeaderAnniversaryBannerBackgroundHolder = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  display: flex;
  align-items: center;
`;

export const LayoutHeaderAnniversaryBannerContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 12px;
  padding-right: 16px;

  @media all and (max-width: 639px) {
    padding-right: 12px;
  }
`;

export const LayoutHeaderAnniversaryBannerContentLeft = styled.div`
  flex: 1;
  display: flex;
  height: 64px;
  align-items: center;

  > svg {
    margin-right: -48px;

    @media all and (max-width: 639px) {
      margin-left: -40px;
      margin-right: -64px;
    }
  }
`;

export const LayoutHeaderAnniversaryBannerLeftExtraSquiggle = styled.div`
  position: absolute;
  left: 120px;
  height: 100%;

  @media all and (min-width: 640px) {
    display: none;
  }
`;

export const LayoutHeaderAnniversaryBannerRightSquiggle = styled.div`
  position: absolute;
  right: 0;
`;

export const LayoutHeaderAnniversaryBannerText = styled.div`
  color: ${colors.white};
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.08px;

  @media all and (min-width: 640px) and (max-width: 991px) {
    max-width: 323px;
  }
`;

export const LayoutHeaderAnniversaryBannerTitle = styled.span`
  font-weight: ${fontWeights.bold};
`;

export const LayoutHeaderAnniversaryBannerMessage = styled.span`
  @media all and (max-width: 639px) {
    display: none;
  }
`;

export const LayoutHeaderAnniversaryBannerFooter = styled.footer`
  display: flex;
  gap: 8px;
  margin-left: 36px;
`;

export const LayoutHeaderAnniversaryBannerButton = styled(ButtonOrLink)`
  background: ${colors.white};
  padding: 12px;
  height: 39px;
  border-radius: 7px;
  color: ${colors.brandBlue};
  font-size: 14px;
  font-weight: ${fontWeights.semiBold};
  display: flex;
  align-items: center;
  text-decoration: none;

  > span[data-short] {
    @media all and (min-width: 640px) {
      display: none;
    }
  }

  > span[data-long] {
    @media all and (max-width: 639px) {
      display: none;
    }
  }
`;

export const LayoutHeaderAnniversaryBannerCloseButton = styled(ButtonOrLink)`
  color: ${colors.elementGrey};
  transition: color ${transition};

  &:hover {
    color: ${colors.white};
  }
`;
